import styled from 'styled-components';

export default styled.div`
  display: inline-block;
  max-width: 145px;
  color: ${({ hasErrors = false }) => (hasErrors ? 'yellow' : 'white')};
`;
